import React from "react";
import MatchupTeams from "../MatchupTeams";
import TeamPlayerInjuries from "../../Team/TeamPlayerInjuries";
import { SubscriptionContext } from "../../../services/SubscriptionService";
import { WebSportItem } from "src/constants";

/**
 * Split panel to display player lineups in a matchup
 */
const MatchupTeamsPlayerInjuries = ({ event, currentSportObj }: { event: any; currentSportObj: WebSportItem }) => {
  return (
    <SubscriptionContext.Consumer>
      {({ hasSubscriptionAccess }) => {
        const { freeGame, league } = event;
        const leagueName = league.name;
        const hasAccess = freeGame || hasSubscriptionAccess(leagueName);
        return (
          <MatchupTeams
            event={event}
            currentSportObj={currentSportObj}
            panelName="Injuries"
            trackingKey="Injury"
            awayTeamContent={<TeamPlayerInjuries game={event} team={event.awayTeam} hasAccess={hasAccess} />}
            homeTeamContent={<TeamPlayerInjuries game={event} team={event.homeTeam} hasAccess={hasAccess} />}
          />
        );
      }}
    </SubscriptionContext.Consumer>
  );
};

export default MatchupTeamsPlayerInjuries;
